
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 0L5 1H0v2h1v15c0 1.093.907 2 2 2h10c1.093 0 2-.907 2-2V3h1V1h-5l-1-1H6zM3 3h10v15H3V3z","fill":"#fff","fill-opacity":".7"}})])
          )
        }
      }
    